import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// STYLES
import { Container } from './styles';

const SellInternetSection = () => {
  const [t] = useTranslation();
  const { partner } = useSelector(({ partner: partnerState }) => ({
    partner: partnerState.data || {},
  }));
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const textOverwrites = partner.text_overwrites || {};

  return (
    <Container className="section section--dark sellInternet">
      <div className="page-content">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} sm={8}>
            <Typography
              className="sellInternet__title text-bold m-b-10"
              component="h2"
              variant={downXs ? 'h5' : 'h3'}
            >
              {textOverwrites.tv_sell_int_title ||
                t('sellInternetSection.title', { partner_name: partner.partner_name })}
            </Typography>
          </Grid>
          <Grid className="text-center" item xs={12} sm={4}>
            <Button
              href={textOverwrites.tv_sell_int_url || partner.home_link || ''}
              size={clsx(downXs ? 'medium' : 'large')}
              color="primary"
              target="_blank"
            >
              {textOverwrites.tv_sell_int_button_text || t('buttons.checkAvailability')}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default React.memo(SellInternetSection);
